<template>
    <div
        v-if="customExpiration"
        class="d-flex align-items-start justify-content-center"
    >
        <span
            class=" custom-expiration position-absolute mt-4 font-weight-bold"
            style="margin-right: 80px;"
            :style="{ color: timerColor }"
        >
            Expiring in
        </span>

        <canvas
            id="timerCanvas"
            class="d-flex mt-2 customTimerCanvas"
            style="margin-left: 85px;"
        ></canvas>
        <span
            id="timerLabel"
            class="timer-label font-weight-bold position-absolute mt-4"
            style="margin-left: 85px;"
            :style="{ color: timerColor }"
            >{{ getMinutes }}:{{ getSeconds }}</span
        >
    </div>
    <div v-else class="d-flex align-items-start justify-content-center">
        <canvas id="timerCanvas" class="d-flex mt-2 originalTimerCanvas"></canvas>
        <span
            id="timerLabel"
            class="font-lg font-weight-bold position-absolute mt-5"
            :style="{ color: timerColor }"
            >{{ getMinutes }}:{{ getSeconds }}</span
        >
    </div>
</template>
<script>
export default {
    props: {
        minutes: {
            type: Number,
            default: 15
        },
        seconds: {
            type: Number,
            default: 0
        },
        customExpiration: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentMinutes: this.minutes,
            currentSeconds: this.seconds,
            countDownDate: null,
            originalDistance: 0,
            canvas: null,
            radialPercentage: null,
            timerColor: "#319E55"
        };
    },
    mounted() {
        this.canvas = document.getElementById("timerCanvas");
        this.startTimer();
    },
    computed: {
        getMinutes() {
            return this.formatTimeUnits(this.currentMinutes);
        },
        getSeconds() {
            return this.formatTimeUnits(this.currentSeconds);
        }
    },
    methods: {
        startTimer() {
            let vm = this;
            let interval = 500;
            let today = new Date();
            var expected = today.getTime() + interval;

            today.setMinutes(today.getMinutes() + this.minutes);
            today.setSeconds(today.getSeconds() + this.seconds);
            this.countDownDate = today.getTime();
            this.originalDistance = this.countDownDate - Date.now();
            var x = setInterval(function() {
                var distance = vm.countDownDate - Date.now();
                if (distance <= 0) {
                    vm.currentMinutes = 0;
                    vm.currentSeconds = 0;
                    vm.$emit("end", vm.startTimer);
                    clearInterval(x);
                } else {
                    vm.radialPercentage =
                        (360 / 100) *
                        (100 - (distance / vm.originalDistance) * 100);
                    vm.currentMinutes = Math.floor(
                        (distance % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    vm.currentSeconds = Math.floor(
                        (distance % (1000 * 60)) / 1000
                    );
                    if (distance < 600000 && distance > 300000) {
                        vm.timerColor = "#FF9900";
                    } else if (distance < 300000) {
                        vm.timerColor = "#FF6166";
                    } else {
                        vm.timerColor = "#319E55";
                    }
                }
            }, interval);

            this.arcMove();
        },
        formatTimeUnits(val) {
            return ("0" + val).slice(-2);
        },
        arcMove() {
            let vm = this;
            let context = vm.canvas.getContext("2d");

            let posX = vm.canvas.width / 2,
                posY = vm.canvas.height / 2,
                interval = 500,
                oneProcent = 360 / 100,
                result = oneProcent * 64;

            context.lineCap = "round";

            let degrees = vm.radialPercentage;
            let arcInterval = setInterval(function() {
                context.clearRect(0, 0, vm.canvas.width, vm.canvas.height);

                context.beginPath();
                context.arc(
                    posX,
                    posY,
                    70,
                    (Math.PI / 180) * 270,
                    (Math.PI / 180) * (270 + 360)
                );
                context.strokeStyle = vm.timerColor;
                context.lineWidth = "5";
                context.stroke();

                context.beginPath();
                context.strokeStyle = "#D9D9D9";
                context.lineWidth = "5";
                context.arc(
                    posX,
                    posY,
                    70,
                    (Math.PI / 180) * 270,
                    (Math.PI / 180) * (270 + vm.radialPercentage)
                );
                context.stroke();
                if (vm.radialPercentage >= 360) clearInterval(arcInterval);
            }, interval);
        }
    }
};
</script>
<style scoped>
.customTimerCanvas{
    height: auto;
    width: 120px;
}

.originalTimerCanvas{
    height: auto;
    width: 230px;
}

.custom-expiration{
font-family: Roboto;
font-size: 20px;
font-weight: 500;
line-height: 28px;
letter-spacing: 0em;
text-align: center;

}

.timer-label{
font-family: Roboto;
font-size: 14px;
font-weight: 500;
line-height: 28px;
letter-spacing: 0.0125em;
text-align: left;

}
</style>
